const parseLocalDateString = (value: string) => {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year, month - 1, day);
};

const TASK_DATE_LOCALE = 'en-US';

const formatUtcCalendarDate = (value: string) => {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day));
};

const getTodayDate = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};

export const isTaskDueDateOverdue = (dueDate: string | undefined) => {
  if (!dueDate) {
    return false;
  }

  return parseLocalDateString(dueDate).getTime() < getTodayDate().getTime();
};

export const formatTaskDate = (dateString: string | undefined, emptyFallback = '-') => {
  if (!dateString) {
    return emptyFallback;
  }

  return formatUtcCalendarDate(dateString).toLocaleDateString(TASK_DATE_LOCALE, {
    timeZone: 'UTC',
  });
};

export const formatTaskDateTime = (dateString: string | undefined, emptyFallback = '-') => {
  if (!dateString) {
    return emptyFallback;
  }

  return new Date(dateString).toLocaleString(TASK_DATE_LOCALE);
};